import { FETCH_ALL_APTS_URL } from './constants';
import { Appointment } from './fetchAppointmentsV2';
import fetchWithRefresh from './fetchWithRefresh';

export default async function getAllDoctorApts({
    clinicId,
    startTime,
    endTime,
    since,
    docIds,
    status,
    getArchived,
    visitType,
}: {
    clinicId: string;
    startTime: string;
    endTime: string;
    since?: string;
    docIds: string[];
    status?: string[];
    getArchived?: boolean;
    visitType?: 'REG' | 'FLW';
}): Promise<{ apts: Appointment[]; time_cursor?: string }> {
    try {
        const headers = new Headers();
        headers.append('accept', 'application/json');
        headers.append('doc-ids', docIds.join(','));

        if (since) {
            headers.append('if-modified-since', since);
        }

        const requestOptions: RequestInit = {
            method: 'GET',
            headers,
            credentials: 'include',
        };

        const url = new URL(FETCH_ALL_APTS_URL({ clinicId, startTime, endTime }));

        if (status && status.length) {
            url.searchParams.set('status', status.join(','));
        }

        if (typeof getArchived === 'boolean') {
            url.searchParams.set('get_archived', `${getArchived}`);
        }

        if (visitType) {
            url.searchParams.set('visit_type', visitType);
        }

        const response = await fetchWithRefresh(url.toString(), requestOptions);
        const allQueuesResponse = await response.json();
        const { data } = allQueuesResponse;

        return data || { apts: [] };
    } catch (e) {
        console.error(e);
        return { apts: [] };
    }
}
